import { render } from "./admin-top-box.vue?vue&type=template&id=75fa9baf"
import script from "./admin-top-box.vue?vue&type=script&lang=js"
export * from "./admin-top-box.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__